// extracted by mini-css-extract-plugin
export default {"detailedContentWrap":"styles_detailedContentWrap__afil5","detailedContentWrapActive":"styles_detailedContentWrapActive__x53PI","detailedContent":"styles_detailedContent__tIxES"};